<template>
  <div v-if="!isHidden" class="wrapper">
    <div :class="['content', { 'has-back': backVisible }]" @click="handleBack">
      <div class="cup-icon">
        <CupIcon />
      </div>
      <div class="bg-rect-left"></div>
      <div class="bg-rect-bottom-warpper"></div>
      <div class="bg-rect-bottom"></div>
      <div class="msg-warpper">
        <div class="msg-text">{{ desc }}</div>
        <div v-if="backVisible" class="msg-button">返回课程目录</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { CallStatus } from '@/store/modules/common/types';
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CupIcon from './assets/CupIcon.vue';
const commonModal = namespace('common');
@Component({
  components: {
    CupIcon
  }
})
export default class End extends Vue {
  @Prop({ type: Object }) content!: Content & {
    isBack?: string;
    desc?: string;
  };
  @commonModal.State('callStatus') callStatus: CallStatus;

  defaultBackVisible = true;
  defaultDesc = '恭喜你完成学习！';

  get backVisible() {
    if (typeof this.content.isBack === 'string' && this.content.isBack?.includes('是')) {
      return true
    }

    if (typeof this.content.isBack === 'string' && this.content.isBack?.includes('否')) {
      return false;
    }
    
    return this.content.isBack ?? this.defaultBackVisible;
  }

  get desc() {
    return this.content.desc ?? this.defaultDesc;
  }

  get isHidden() {
    return this.$route.query?.type === 'preview' && this.$route.path.startsWith('/main') && this.$route.params.pathMatch.startsWith('https')
  }

  mounted() {
    // 向上抛出评分
    if (!this.isHidden) {
      this.$nextTick(() => {
        if (this.callStatus.isroll) {
          this.$PostConnection?.command('rating_course');
          // 主动上报完课(晚于常规埋点)
          setTimeout(() => {
            window.$tracker?.tracker?.pageFinish({ resource_id: this.content.$id });
          }, 0);
        }
      });
    }
  }

  handleBack() {
    if (this.backVisible) {
      this.$PostConnection?.command('redirect_course');
    }
  }
}
</script>

<style scoped>
.wrapper {
  @apply w-full sm:w-120 h-36 mb-8 mt-4 sm:ml-12 md:ml-12 overflow-hidden;
  max-width: 28rem;
  transition: 0.3s;
}

.content {
  @apply relative w-full h-full rounded-motif;
  background: linear-gradient(269.87deg, #91dfbc -108.18%, #91dfbc 99.89%);
}

.content.has-back {
  @apply cursor-pointer;
}

.wrapper:hover {
  transform: translateY(-0.25rem);
}

.msg-warpper {
  @apply absolute w-3/5 h-full flex flex-col items-center justify-center;
  z-index: 1;
}

.msg-text {
  @apply font-semibold text-white mb-2;
  font-size: 22px;
}

.msg-button {
  @apply flex items-center justify-center text-white font-medium;
  width: 120px;
  height: 34px;
  font-size: 14px;
  background: #60bd93;
  border-radius: 3px;
}

.cup-icon {
  @apply absolute right-0 bottom-0;
  z-index: 1;
}

.bg-rect-left {
  @apply absolute top-0 left-0;
  width: 120px;
  height: 107px;
  background: linear-gradient(180deg, rgba(145, 223, 188, 0.2) 0%, rgba(217, 255, 238, 0.2) 100%);
  border-radius: 10px;
  transform: matrix(0.87, -0.51, 0.49, 0.87, 0, 0) translate(-15%, -50%);
}

.bg-rect-bottom-warpper {
  @apply absolute top-0 left-0;
  width: 244.41px;
  height: 107.37px;
  background: linear-gradient(186deg, rgba(89, 216, 159, 0.3) 5%, rgba(217, 255, 238, 0.3) 425%);
  border-radius: 10px;
  transform: matrix(0.87, -0.51, 0.49, 0.87, 0, 0) translate(-5%, 50%);
}

.bg-rect-bottom {
  @apply absolute top-0 left-0;
  width: 121px;
  height: 107px;
  background: linear-gradient(180deg, rgba(145, 223, 188, 0.2) 0%, rgba(217, 255, 238, 0.2) 100%);
  border-radius: 10px;
  transform: matrix(0.87, -0.51, 0.49, 0.87, 0, 0) translate(50%, 100%);
}
</style>
